import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";
import UseStyles from "./UseStyles";
import NmefSpinner from '../../NmefSpinner';
import { DocsDataAPI } from "../../API/DocsDataAPI";
import useAPIError from "../../APIError";
import { ThemeProvider } from "@material-ui/core/styles";
import {
  applicationDataListMap,
  applicationDealDataList,
  applicationGuarantorDataList,
  checkInvoiceWithAssetFeeTotal,
  applicationUpdateDataList,
  checkAssetType,
} from "./SummaryHelper";
import SummaryTheme from "./SummaryTheme";
import SummaryCombinedAll from "./summaryCombinedAll";
import SummaryContext from "../../DocsFunding/Summary/SummaryContext";

const Summary = ({ app, isReadOnly }) => {
  const classes = UseStyles();
  const { addError } = useAPIError();
  const [isShow, setIsShow] = useState(false);
  const [application, setApplication] = useState({});
  const [dealDataList, setDealDataList] = useState([]);
  const [guarantorDataList, setGuarantorDataList] = useState([]);
  const [originalGuarantors, setOriginalGuarantors] = useState([]);
  const [applicantDataList, setApplicantDataList] = useState({});
  const [ownerData, setOwnerData] = useState({
    current_owner_name: "",
    previous_owner_name: "",
    currentState: 0,
  });
  const [assetType, setAssetType] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [alertModal, setAlertModal] = React.useState({
    isSubmitting: false,
    open: false,
    message: "",
    status: "",
  });

  useEffect(() => {
    let isMounted = true;
    (async () => {
      if (app && isMounted) {
        try {
          setIsLoading(true);
          let applicationData = await DocsDataAPI.fetchApplicationById(
            app.id,
            app.broker_id,
            app.locked_by_email
          );
          if (applicationData) {
            const currentState = getCurrentGroupOrder(applicationData.status);
            if (currentState === 1)
              setOwnerData({
                current_owner_name: applicationData?.roundrobin_grp_user1,
                previous_owner_name:
                  applicationData?.roundrobin_grp_user2 +
                  " / " +
                  applicationData?.roundrobin_grp_user3,
                currentState: currentState,
              });
            if (currentState === 3) {
              const prevUser1 = applicationData?.roundrobin_grp_user2;
              const prevUser2 =
                applicationData?.roundrobin_grp_user1 !== undefined
                  ? `/ ${applicationData?.roundrobin_grp_user1}`
                  : "";
              setOwnerData({
                current_owner_name: applicationData?.roundrobin_grp_user3,
                previous_owner_name: [prevUser1, prevUser2].concat(),
                currentState: currentState,
              });
            }
            if (currentState === 2)
              setOwnerData({
                current_owner_name: applicationData?.roundrobin_grp_user2,
                previous_owner_name: "",
                currentState: currentState,
              });
          }

          let guarantorData = await DocsDataAPI.fetchApplicationGuarantorsById(
            app.id,
            app.broker_id,
            app.locked_by_email
          );
          if (guarantorData) {
            let guarantorDataList = [];
            guarantorData.forEach((element) => {
              let data = applicationGuarantorDataList(element);
              guarantorDataList.push(data);
            });
            setOriginalGuarantors(guarantorData);
            setGuarantorDataList(guarantorDataList);
          }

          let dealData = await DocsDataAPI.fetchApplicationDealsById(
            app.id,
            app.broker_id,
            app.locked_by_email
          );
          if (dealData) {
            setDealDataList(dealData);
          }

          let fees = await DocsDataAPI.getApplicationFeesById(
            app.id,
            app.broker_id,
            app.locked_by_email
          );
          if (applicationData && fees) {
            let applicationInfoList = await applicationDataListMap(
              applicationData,
              fees
            );
            setApplicantDataList(applicationInfoList);
            setApplication(applicationInfoList);
            setAssetType(await checkAssetType(applicationData));
          }
        } catch (error) {
          addError(error.message);
        } finally {
          setIsLoading(false);
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [app, addError]);

  useEffect(() => {
    if (alertModal?.open) {
      setTimeout(() => {
        setAlertModal({
          isSubmitting: false,
          open: false,
          message: "",
          status: "",
        });
      }, 8000);
    }
  }, [alertModal]);

  const getCurrentGroupOrder = (appStatus) => {
    if (appStatus === "Verbal DnA") return 1;
    else if (
      appStatus === "New" ||
      appStatus === "Submitted" ||
      appStatus === "Pre-Credit Review" ||
      appStatus === "Asset Review" ||
      appStatus === "Credit Review" ||
      appStatus === "Credit Adjudication" ||
      appStatus === "Dealmaker"
    )
      return 2;
    else if (
      appStatus === "Document Data Review" ||
      appStatus === "Documents Sent" ||
      appStatus === "Document Check In" ||
      appStatus === "Funding" ||
      appStatus === "Funded" ||
      appStatus == "Booked"
    )
      return 3;
    else return 0;
  };

  const onFiftyClicked = async (is_fifty_pre_funded) => {
    try {
      if (Object.keys(applicantDataList).length !== 0) {
        const DataList = {
          id: applicantDataList.id,
          broker_id: applicantDataList.broker_id,
          is_fifty_pre_funded: is_fifty_pre_funded,
          fein_ssn: applicantDataList.FEIN,
        };
        await DocsDataAPI.updateApplication(
          DataList,
          applicantDataList.broker_id,
          applicantDataList.locked_by_email
        );
        setApplicantDataList({
          ...applicantDataList,
          is_fifty_pre_funded: is_fifty_pre_funded,
        });
      }
    } catch (error) {
      addError(error.message);
    }
  };
  const applicationEdit = () => {
    setIsShow(false);
  };

  const invoiceAmountChange = (Amount) => {
    var amount = Amount[0] === "$" ? Amount.slice(1) : Amount;
    var result = amount.replace(/,/gi, "");
    console.log("result of amount- " + result);
    setApplication({ ...application, invoice_amount: result });
  };

  const clickCloseOption = (Message) => {
    if (Message === "Close") {
      setAlertModal({
        ...alertModal,
        isSubmitting: false,
        open: false,
        message: "",
        status: "",
      });
    }
  };
  const updateApplication = async (data) => {
    if (data === null) {
      return;
    }
    setAlertModal({
      ...alertModal,
      isSubmitting: true,
    });

    if (
      parseInt(data.invoice_amount) !==
      parseInt(applicantDataList.invoice_amount)
    ) {
      setAlertModal({
        ...alertModal,
        isSubmitting: false,
        open: true,
        message:
          "Could not save as invoice total does not match with the total of asset price and fee amount.",
        status: "error",
      });
      return;
    }
    const DataList = await applicationUpdateDataList(data);
    try {
      await DocsDataAPI.updateApplication(DataList, data.broker_id, app.locked_by_email);
      setAlertModal({
        ...alertModal,
        isSubmitting: false,
        open: true,
        message: "Data updated successfully!",
        status: "success",
      });
      setApplicantDataList(application);
    } catch (error) {
      addError(error.message);
    } finally {
      applicationEdit();
    }
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setApplication({ ...application, [name]: value });
  };

  return (
    <>
      {isLoading ? (
        <Box component="div" className={classes.box_design}>
          <NmefSpinner />
        </Box>
      ) : (
        <SummaryContext.Provider
          value={{
            application,
            applicantDataList,
            app,
            originalGuarantors,
            guarantorDataList,
            dealDataList,
            isShow,
            applicationEdit,
            onFiftyClicked,
            ownerData,
            isReadOnly,
            alertModal,
            updateApplication,
            clickCloseOption,
            invoiceAmountChange,
            handleChange,
            assetType,
          }}
        >
          <ThemeProvider theme={SummaryTheme}>
            <SummaryCombinedAll />
          </ThemeProvider>
        </SummaryContext.Provider>
      )}
    </>
  );
};

export default Summary;
